import { HStack } from '@ayble-health/dashboard-components';
import { Line } from './types';
import { TimeChartLegendItem } from './TimeChartLegendItem';
import { Box } from '@chakra-ui/react';

type Props = {
  dataRangeLabel: string;
  lines?: Line[];
  readonly?: boolean;
  onToggleLegendItem: (dataKey: string, visible: boolean) => void;
};

export const TimeChartLegend = ({
  dataRangeLabel,
  lines,
  onToggleLegendItem,
  readonly,
}: Props) => {
  if (!lines) return null;

  return (
    <HStack>
      {lines.map((line, i) => (
        <Box key={i} mr={6}>
          <TimeChartLegendItem
            dataRangeLabel={dataRangeLabel}
            line={line}
            onToggle={onToggleLegendItem}
            readonly={readonly}
          />
        </Box>
      ))}
    </HStack>
  );
};
